export default __webpack_public_path__ + "static/media/data-screen.06e0decd.png";